import {ChartDecorator} from './chart-decorator';

export class Legend extends ChartDecorator{

  constructor(visible: boolean) {
    super();
  }

}
